import store from "../store";
import moment from "moment";
import {makePostRequest} from "@/helper/requests";

export function getUserToken() {
  /**
   * Функция возвращает токен пользователя из localStorage
   */
    return localStorage.getItem('user-token')
}

export function isWorker() {
  /**
   * Функция проверяет является ли пользователь сотрудником
   * @returns {boolean} - true если пользователь является сотрудником
   */
    return store.state.user.isWorker && localStorage.getItem('isWorker')
}

export function isAuthenticated() {
  /**
   * Функция проверяет аунтификацию пользователя
   * @returns {boolean} - true если пользователь аунтифицирован
   */
    return store.state.user.isAuthenticated && localStorage.getItem('user-token')
}

export function clearUserAuth() {
  /**
   * Функция отчищает localStorage, cookies и производит выход пользователя из системы
   */
    localStorage.removeItem('user-token'); // clear obj.users.exclude(user=self.context['request'].user.db_user).first().user.full_nameyour user's token from localstorage
    localStorage.removeItem('isWorker');
    localStorage.removeItem('username');
    localStorage.removeItem('user-uid');
    window.$cookies.remove("userMuctr");
    store.commit('auth/AUTH_LOGOUT')
}

export function checkIsProductionServer() {
  /**
   * Функция проверяет, работает ли сервер в производственном режиме
   * @returns {boolean} - true если NODE_ENV === 'production'
   */
    return process.env.NODE_ENV === 'production'
}
export function checkIsDevelopmentServer() {
  /**
   * Функция проверяет, работает ли сервер в режиме разработки
   * @returns {boolean} - true если NODE_ENV === 'development'
   */
    return process.env.NODE_ENV === 'development'
}

export function getUserUid() {
  /**
   * Функция получает UID пользователя из localStorage
   * @returns {String} - UID пользователя
   */
    return localStorage.getItem('user-uid');
}


export function makeProfileUrl(url) {
  /**
   * Функция создает url профиля
   * @return {String} - url профиля пользователя
   */
    return url.replace('<user-uid>', getUserUid()).replace('<uuid:user>', getUserUid()).replace('<user>', getUserUid());
}


export function makeManagerUrl(url, manager) {
  /**
   * Функция создает url менеджера
   * @return {String} - url менеджера
   */
    return url.replace('<manager-uid>', manager);
}

export function getDisplay(value, selector) {
    /**
     * Функции выбиращая текстовое отображения для значения из списка выбора
     *
     * @param {string} url - урл с которого загружаются данные
     * @param {function} finalizer - функция которая выполняется после загрузки данных, и сохраняет их
     * @param {function} catcher - функция которая выполняется если загрузка произошла не с кодом ОК
     *
     */
    if (selector) {
        let res = selector.find((el) => {
            if (el.value === value)
                return true
        });
        if (res)
            return res.text;
        else
            return null;
    } else
        return null;
}


export function mapPaginatedResult(from, to) {
    /**
     * Присваивает параметры пагинации к объекту из запроса
     *
     * @param {Object} from - откуда брать параметры пагинации
     * @param {Object} to - куда прокидывать параметры пагинации
     */
    to.next = from.next;
    to.prev = from.previous;
    to.count = from.count;
}

export function checkFieldExist(object, field) {
    /**
     * Проверка существования поля в объекте
     *
     * @param {Object} object - объект в котором проводиться проверка
     * @param {String} field - поле которое проверяется в объекте
     *
     * @return {Boolean} - результат True если есть
     */
    if (object !== Object && object !== Array)
        return false;
    return field in object
}

export function checkFieldTrue(object, field) {
    /**
     * Проверить что поле существуе и оно не null, undefined, False
     *
     * @param {Object} object - объект в котором проводиться проверка
     * @param {String} field - поле которое проверяется в объекте
     *
     * @return {Boolean} - результат True если соответвует условиям
     */
    return checkFieldExist(object, field) && object[field]
}

export function getFieldOrEmpty(object, field) {
    /**
     * Вывод либо значение поля, либо пустую строку
     *
     * @param {Object} object - объект в котором проводиться проверка
     * @param {String} field - поле которое проверяется в объекте
     *
     * @return {Boolean} - результат True если соответвует условиям
     */
    if (checkFieldExist(object, field))
        return object[field];
    return ''
}

export function urlify(text) {
  /**
   * Функция автоматически преобразует URL и email в тексте в кликабельные HTML-ссылки.
   * @param {string} text - Текст для обработки
   * @returns {string} Текст с обернутыми в <a> теги URL
   */
    if (!text) return text;

    // Регулярное выражение для email-адресов
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

    // Регулярное выражение для URL (улучшенное)
    const urlRegex = /((https?:\/\/)?([a-z0-9]+\.)+[a-z]{2,}(:\d{1,5})?(\/[^\s]*)?)/gi;

    // Временный маркер для защиты email-адресов
    const EMAIL_MARKER = '__EMAIL__';
    const emailMap = [];
    let index = 0;

    // Шаг 1: Находим все email-адреса и заменяем их маркерами
    const textWithMarkers = text.replace(emailRegex, (email) => {
        emailMap[index] = email;
        return `${EMAIL_MARKER}${index++}`;
    });

    // Шаг 2: Преобразуем URL в ссылки
    const textWithUrls = textWithMarkers.replace(urlRegex, (url) => {
        // Проверяем, не является ли это частью email (после @)
        if (url.includes('@') || url.startsWith('mailto:')) {
            return url;
        }

        // Добавляем протокол, если его нет
        let href = url;
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            href = 'https://' + url;
        }

        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    // Шаг 3: Восстанавливаем email-адреса
    let result = textWithUrls;
    emailMap.forEach((email, i) => {
        const marker = `${EMAIL_MARKER}${i}`;
        result = result.replace(marker, `<a href="mailto:${email}">${email}</a>`);
    });

    return result;
}

export function displayDate(date, minutes = false) {
    /**
     * Вывод нормального представления даты по русски
     * @param {string} date - строка даты и времени
     * @param {Boolean} minutes - выводить минут или не выводить, по умолчанию нет
     *
     * @return {String} вывод строки даты в нужном виде
     */
    let format = 'DD.MM.YYYY';
    if (minutes)
        format += ' HH:mm';
    return moment(date).format(format)
}
